<div [class.height-100]="!isPdfViewerVisible()"
     [ngClass]="(isImage() || isVideo() || isAudio() || isOfficeDocument()) ? 'flex flex-column vertical-center' : ''"
     class="work-ui-dokumente-viewer work-card no-padding">
  @if (!previewReady() && activeDocument() && !showFileLoadingException()) {
    <work-ui-loading-spinner loadingState="loading" />
  }

  @if (isPdfViewerVisible()) {
    <ngx-extended-pdf-viewer (pdfLoaded)="onPdfLoaded()"
                             (pdfLoadingFailed)="onFileLoadException()"
                             (pdfLoadingStarts)="isPdfLoaded.set(false)"
                             [class.fade-in-forwards]="previewReady() && !showFileLoadingException() && !isImage() && !isVideo() && !isAudio() && !isOfficeDocument()"
                             [enablePrint]="true"
                             [ignoreKeys]="isPdfLoaded() ? [] : ['ctrl+s', 'cmd+s', 'ctrl+p', 'cmd+p']"
                             [filenameForDownload]="activeDocument()?.name || environment.tenantCompanyCommonName + '-Dokument'"
                             [showBorders]="false"
                             [showDownloadButton]="isPdfLoaded()"
                             [showPrintButton]="isPdfLoaded()"
                             [showOpenFileButton]="false"
                             [showSecondaryToolbarButton]="false"
                             [showSidebarButton]="false"
                             [showStampEditor]="false"
                             [sidebarVisible]="false"
                             [(src)]="activeDocumentUrl"
                             backgroundColor="#ffffff"
                             language="de"
                             zoom="page-fit" />
  }

  @if (isImage() && !showFileLoadingException()) {
    <img (error)="onFileLoadException()"
         [class.fade-in-forwards]="previewReady()"
         [src]="activeImageUrl() | prependServerToFileSrc"
         [alt]="'DOKUMENTENANSICHT' | translate">
  }

  @if (isVideo() && !showFileLoadingException()) {
    <video (error)="onFileLoadException()"
           [class.fade-in-forwards]="previewReady()"
           [src]="activeVideoUrl()"
           class="work-ui-dokumente-viewer__video"
           controls>
      {{ 'VIDEO_WIRD_NICHT_UNTERSTUETZT' | translate }}
    </video>
  }

  @if (isAudio() && !showFileLoadingException()) {
    <div [class.fade-in-forwards]="previewReady()" class="work-ui-dokumente-viewer__state-info">
      <work-ui-icon [fontSize]="48" name="audio_file" />
      <p class="work-text-align-center work-text-color-light">{{ activeDocument()?.name }}</p>
      <audio (error)="onFileLoadException()"
             [src]="activeAudioUrl()"
             class="width-100"
             controls>
        {{ 'AUDIO_WIRD_NICHT_UNTERSTUETZT' | translate }}
      </audio>
    </div>
  }

  @if (isOfficeDocument() && !showFileLoadingException()) {
    <div [class.fade-in-forwards]="previewReady()" class="work-ui-dokumente-viewer__state-info">
      <work-ui-icon [fontSize]="48" name="description" />
      <h3 class="work-text-align-center">{{ 'OFFICE_DOKUMENT_VORSCHAU_NICHT_VERFUEGBAR' | translate }}</h3>
      <p class="work-text-align-center">{{ 'OFFICE_DOKUMENT_VORSCHAU_NICHT_VERFUEGBAR_BESCHREIBUNG' | translate }}</p>
      <work-ui-button (buttonClick)="openInNewTab()" iconName="download" text="HERUNTERLADEN" />
    </div>
  }

  @if (showFileLoadingException()) {
    <div class="work-ui-dokumente-viewer__state-info error">
      <work-ui-icon [fontSize]="48" name="error" />
      <h3>{{ 'DATEI_FEHLER_BEIM_LADEN' | translate }}</h3>
      <p>{{ 'DATEI_EXISTIERT_NICHT_ODER_FEHLERHAFT' | translate }}</p>
    </div>
  }

  @if (!activeDocument()) {
    <div class="work-ui-dokumente-viewer__state-info">
      <work-ui-icon [fontSize]="128" name="folder_open" />
    </div>
  }
</div>
